import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';
import DialogFactory from '../picker/dialogFactory';
import IPSDialog from '../picker/dialog';
import style from './style.vue';
import { IPSService } from '@/services/ipsServices';
import { Functions } from '@/library/utils/functions';

@DialogFactory
@Component({
  mixins: [style],
})
export default class ActivityLink extends IPSDialog {
  page = 1;

  pageSize = 10;

  total = 0;

  dataList = [];

  keyword = '';

  siteCodes = [];

  confirm = false;

  title = '活动列表';

  mounted() {
    this.getActList();
  }

  getActList() {
    const postParams = {
      actTypeId: 0,
      actState: 7,
      page: this.page, // 页数
      pageNum: this.pageSize, // 每页个数
      keyword: this.keyword, // 活动名称
      siteCodes: this.siteCodes,
    };
    IPSService.getActivityList({ postParams })
      .then((res) => {
        this.dataList = res.list;
        this.total = res.count;
      })
      .catch((err) => {});
  }

  onSizeChange(val) {
    this.page = 1;
    this.pageSize = val;
    this.getActList();
  }

  onPageChange(val) {
    this.page = val;
    this.getActList();
  }

  handleSearch() {
    this.page = 1;
    this.getActList();
  }

  onSelect(id, name) {
    this.$emit('result', { id, name });
    this.$emit('hidden');
  }

  activityTime(val) {
    if (val.actStartTime === 0) {
      return '-';
    } else {
      return `${Functions.timeFormat(val.actStartTime)}~${Functions.timeFormat(val.actEndTime)}`;
    }
  }

  renderContent(h) {
    return (
      <div class="select-list">
        <div class="filterController">
          <div class="inputWrapper">
            <el-input v-model={this.keyword}></el-input>
            <i class="iconfont iconsousuo" onClick={this.handleSearch.bind(this)}></i>
          </div>
        </div>
        <el-table data={this.dataList} height="350px" style="width: 100%" tooltip-effect="light">
          <el-table-column type="index" label="ID" width="40" />
          <el-table-column prop="actId" label="活动ID" width="100" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column
            prop="actTitle"
            label="活动名称"
            width="280px"
            align="center"
            show-overflow-tooltip
            {...{
              scopedSlots: {
                default: (scope) => {
                  return (
                    <span>
                      {scope.row.orderType == 1 ? '【线上】' : ''}
                      {scope.row.actTitle}
                    </span>
                  );
                },
              },
            }}></el-table-column>
          <el-table-column prop="actType" label="活动类型" align="center" show-overflow-tooltip width="140px" />
          <el-table-column
            prop="actStartTimeStr"
            label="活动期间"
            align="center"
            width="350px"
            show-overflow-tooltip
            {...{
              scopedSlots: {
                default: (scope) => {
                  return <span>{this.activityTime(scope.row)}</span>;
                },
              },
            }}></el-table-column>
          <el-table-column
            label="操作"
            width="80px"
            align="center"
            {...{
              scopedSlots: {
                default: (scope) => {
                  return (
                    <span class="scopeSpan" onClick={this.onSelect.bind(this, scope.row.actId, scope.row.actTitle)}>
                      选中
                    </span>
                  );
                },
              },
            }}></el-table-column>
        </el-table>
        <div class="bottomWrapper">
          <el-pagination
            on-size-change={val => this.onSizeChange(val)}
            on-current-change={val => this.onPageChange(val)}
            current-page={this.page}
            page-sizes={[10, 15, 20, 30]}
            page-size={this.pageSize}
            layout="total, sizes, prev, pager, next, jumper"
            total={this.total}></el-pagination>
        </div>
      </div>
    );
  }
}
